import axiosInstance from '../auth/axiosInstance';

export type SecurityLog = {
  id: number;
  eventTime: string;
  eventType: string;
  userId: number | null;
  userName: string | null;
  userEmail: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  detail: string | null;
};

export type SecurityLogQuery = {
  pageNumber: number;
  pageSize: number;
  eventType?: string;
  /** Last N days; 0 / undefined = all time. */
  days?: number;
  search?: string;
};

export type SecurityLogPage = {
  items: SecurityLog[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
};

/** SuperAdmin-only: GET api/Log/security-events (paged, filterable). */
export const getSecurityLogs = async (query: SecurityLogQuery): Promise<SecurityLogPage> => {
  const { data: result } = await axiosInstance.get('/Log/security-events', {
    params: {
      pageNumber: query.pageNumber,
      pageSize: query.pageSize,
      eventType: query.eventType || undefined,
      days: query.days || undefined,
      search: query.search?.trim() || undefined,
    },
  });

  if (result?.succeeded === false) {
    throw new Error(result.message || 'Failed to load security logs.');
  }

  const page = result?.data ?? {};
  return {
    items: Array.isArray(page.data) ? page.data : [],
    totalCount: page.totalRecords ?? 0,
    pageNumber: page.pageNumber ?? query.pageNumber,
    pageSize: page.pageSize ?? query.pageSize,
    totalPages: Math.max(1, page.totalPages ?? 1),
  };
};
